import * as React from 'react';
import {LANG_EN, LANG_EN_US} from "language/langutil";
import svcs from "services";
import {Helmet} from 'react-helmet-async';

type Props = {};
export const AppHelmet = ({}: Props) => {
  const lang = svcs.svcLang.lang(); // ( 언어-국가 ) 로 처리해도 됨.
  return (
    <Helmet htmlAttributes={{lang}}>
      {
        [LANG_EN, LANG_EN_US].includes(lang) ? <>
          <meta content="The only website needed for anything related to LS Electric Automation Products" name="description"/>
          <meta
            content="SOLUTION SQUARE, Smart Factory, LS ELECTRIC, Smart Factory, Automation equipment information, Platform, PLC, Drive, Inverter, HMI, Q&A, Energy Saving, Community, Engineering, Automation, Automation material, LSIS"
            name="keywords"/>
          <meta content="Solution Square" property="og:title"/>
          <meta content="The only website needed for anything related to LS Electric Automation Products"
            property="og:description"/>
        </> : <>
          <meta content="LS ELECTRIC 자동화 엔지니어링의 모든 것" name="description"/>
          <meta
            content="솔루션스퀘어, SOLUTION SQUARE, 스마트팩토리, LS ELECTRIC 스마트팩토리, 스마트공장, 자동화 기기 정보 제공, 플랫폼, PLC, Drive, 드라이브, 인버터, HMI, 샘플, 엔지니어링, 자동화, 자동화 자료, Automation"
            name="keywords"/>
          <meta content="Solution Square - 솔루션스퀘어" property="og:title"/>
          <meta content="LS ELECTRIC 자동화 엔지니어링의 모든 것" property="og:description"/>
        </>
      }
    </Helmet>
  );
};